import React from 'react';

export default function Header({
    centerTitle = 'OxyCrystals',
}) {
    return (
        <div className="w-full h-[30px] px-[15px] flex items-center justify-center">
            <span className="text-[#EAEAEA] text-[18px] font-semibold">
                {centerTitle}
            </span>
        </div>
    );
}
